import { Injectable } from "@angular/core";

import { map, Observable, of, catchError } from "rxjs";

import { ApiRequestDispatcherService } from "../../../../shared-library/services/api/api-request-dispatcher.service";
import { BaseSearchResultsModel } from "../../models/base-search-results.model";
import { DirectoryItemModel } from "../models/directory-item.model";
import { SearchParametersModel } from "../models/search-parameters.model";
import { SearchFilterMetadataModel } from "../../models/search-filter-metadata.model";

@Injectable({
    providedIn: "root"
})
export class DirectorySearchService {
    private readonly API_GET_LIST_URL = "/api/s4s-advanced-search/directory-search/get-list";

    public constructor(
        private _requestDispatcher: ApiRequestDispatcherService
    ) {
    }

    public getSearchResults(searchParams: SearchParametersModel): Observable<BaseSearchResultsModel<DirectoryItemModel>> {
        return this._requestDispatcher.get<BaseSearchResultsModel<DirectoryItemModel>>(this.API_GET_LIST_URL, {searchParams: JSON.stringify(searchParams)}).pipe(
            catchError(error => {
                console.error(error);
                return of({pageNumber: 1, pageSize: searchParams.pageSize, totalPages: 0, totalItems: 0, pageItems: [], recommendedLinks: []});
            })
        );
    }

    public getDirectoryItem(eventId: string): Observable<DirectoryItemModel> {
        return this._requestDispatcher.get<DirectoryItemModel>("/api/s4s-advanced-search/directory-search/get-event/" + eventId);
    }

    public getTemplateMetadata(templateId: string): Observable<Array<SearchFilterMetadataModel>> {
        return this._requestDispatcher.get<Array<SearchFilterMetadataModel>>("/api/s4s-advanced-search/directory-search/get-search-filters/" + templateId);
    }
}
